export const LOGIN_URL = '/login';

export function getLoginUrl(): string {
  return LOGIN_URL;
}

const DASHBOARD_PATHS: Record<string, string> = {
  company_admin: '/company-admin',
  branch_admin: '/branch-admin',
  user: '/crm',
};

export function dashboardPathForRole(adminLevel?: string, _teamRole?: string | null): string {
  return DASHBOARD_PATHS[adminLevel ?? ''] ?? LOGIN_URL;
}
